
import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiShield, FiSettings, FiUsers } from 'react-icons/fi';
import heroBg from '../assest/hero-static-bg.png';

const trustItems = [
  { icon: FiShield, title: 'Quality Assurance' },
  { icon: FiSettings, title: 'Advanced Technology' },
  { icon: FiUsers, title: 'Customer Satisfaction' },
];

// Static hero — replaces the old multi-slide carousel with a single fixed
// background image, per the approved design reference.
export default function HeroSlider() {
  return (
    <section
      className="hero-section relative flex min-h-[560px] w-full items-center overflow-hidden bg-navy pb-10 pt-24 sm:min-h-[620px] sm:pb-12 sm:pt-28 lg:min-h-[100dvh] lg:max-h-[720px] lg:py-0"
    >
      {/* Background layer — lighter overlay so the image reads brighter, image itself never moves */}
      <div
        className="hero-bg absolute inset-0"
        style={{
          backgroundImage: `linear-gradient(90deg, rgba(18,10,59,0.68) 0%, rgba(18,10,59,0.50) 32%, rgba(18,10,59,0.18) 68%, rgba(18,10,59,0.05) 100%), url(${heroBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'right center',
        }}
      />

      {/* Shimmer sweep — soft diagonal light band passing over the whole hero image on loop */}
      <div className="hero-sweep pointer-events-none absolute inset-0 z-[1]" />

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mt-10 sm:mt-16 lg:mt-24">
        


          <h1 className="mt-4 text-3xl font-extrabold uppercase leading-[1.15] text-white sm:text-4xl lg:text-5xl xl:text-6xl">
            <span className="hero-mask block" style={{ animationDelay: '260ms' }}>Providing</span>
            <span className="hero-mask block" style={{ animationDelay: '440ms' }}>
              <span className="hero-shimmer text-brand-orange">Services</span>
            </span>
            <span className="hero-mask block" style={{ animationDelay: '620ms' }}>Beyond the ordinary</span>
          </h1>

          <p className="hero-mask mt-4 max-w-lg text-sm leading-relaxed text-white/80 sm:text-base lg:text-lg" style={{ animationDelay: '820ms' }}>
            Delivering premium electrical equipment and complete power transmission solutions for industries and infrastructure projects.
          </p>

          <div className="hero-mask mt-6" style={{ animationDelay: '980ms' }}>
            <Link
              to="/products"
              className="hero-cta group inline-flex items-center gap-2 rounded-full bg-brand-orange px-6 py-3 text-sm font-bold uppercase tracking-wide text-white transition hover:-translate-y-0.5 hover:bg-brand-orangedark"
            >
              Explore More
              <FiArrowRight className="transition-transform duration-300 group-hover:translate-x-1" size={16} />
            </Link>
          </div>

          <div className="hero-mask mt-8 flex flex-wrap items-center gap-5 border-t border-white/15 pt-5 sm:gap-8" style={{ animationDelay: '1140ms' }}>
            {trustItems.map((item, i) => {
              const Icon = item.icon;
              return (
                <React.Fragment key={item.title}>
                  {i > 0 && <span className="hidden h-8 w-px bg-white/15 sm:block" />}
                  <div className="hero-trust-item flex items-center gap-2.5">
                    <span className="hero-trust-icon flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-brand-orange/50 text-brand-orange transition-all duration-300 sm:h-9 sm:w-9">
                      <Icon size={16} />
                    </span>
                    <span className="text-xs font-semibold uppercase tracking-wide text-white/90 sm:text-sm">
                      {item.title}
                    </span>
                  </div>
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>

      {/* styles unchanged — keep your existing <style> block */}
    </section>
  );
}

